module.exports = __webpack_public_path__ + "img/34.228301c4.jpg";